import { render, staticRenderFns } from "./invoicepreviewComponent.vue?vue&type=template&id=10e828f5&scoped=true"
import script from "./invoicepreviewComponent.vue?vue&type=script&lang=js"
export * from "./invoicepreviewComponent.vue?vue&type=script&lang=js"
import style0 from "./invoicepreviewComponent.vue?vue&type=style&index=0&id=10e828f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e828f5",
  null
  
)

export default component.exports